import React from 'react';
import { Helmet } from 'react-helmet';
import BArrowImg from "../../../_assets/Arrow 1.png";
import { Grid, Button, Dropdown, Form, Image } from "semantic-ui-react";

const CreateVMCohertForm = ({
  name,
  areaName,
  lat,
  lng,
  vmList,
  vmLoading,
  userLoading,
  userList,
  onChangeOfName,
  onChangeOfAreaName,
  onChangeOfDescription,
  description,
  onChangeOfLat,
  onChangeOfLng,
  onChangeOfVM,
  onChangeOfUser,
  submitting,
  handleSubmit,
  cohorts_types,
  onChangeOfCohortTypeId,
 
  handleBack,
}) => (
  <Grid centered style={{ marginTop: "0px", padding: "10vh" }}>
  <Helmet>
 <title>Create Vending Machine Cohort</title>
</Helmet>
<Grid.Row Column={3} style={{ display: "flex", "justify-content": "just" }}>
 <Grid.Column width={1}>
   <span style={{ "margin-top": "1.5rem" }}>
  <Image   onClick={handleBack}  className={"backarrow"} src={BArrowImg} /> 
   </span>
 </Grid.Column>
 <Grid.Column width={9}>
   <h2>Create Vending Machine Cohort</h2>
 </Grid.Column>
</Grid.Row>
   
<Grid.Row  style={{ marginBottom: "8em" }}>
      <Grid.Column width={8}>
      <Form>
      <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>COHORT NAME</label>
            <input
              placeholder="Enter Cohorts Name "
              value={name}
             onChange={onChangeOfName} 
               
              style={{
                        
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
            />
          </Form.Field>
          
          <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>COHORT TYPE</label>
            <Dropdown
              placeholder="Select Hardware Type"
             // loading={loading}
              selection
              search
              options={cohorts_types}
              onChange={onChangeOfCohortTypeId} 
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>
       
          <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>AREA NAME</label>
            <input
              placeholder="Enter Area Name "
              value={areaName}
             onChange={onChangeOfAreaName} 
               
              style={{
                        
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
            />
          </Form.Field>

          <Form.Field required>
            <label>Select Users</label>
            <Dropdown
              disabled={userLoading || submitting}
              onChange={onChangeOfUser}
              selection
              search
              multiple
              options={userList || []}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

          <Form.Field required>
            <label>Select Vending Machines</label>
            <Dropdown
              disabled={vmLoading || submitting}
              onChange={onChangeOfVM}
              selection
              search
              multiple
              options={vmList || []}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>
          
          <div  style={{"display": "flex",marginBottom:"3rem"}}>
           
           <Form.Field required style={{width:"52%"}}>
            <input
              placeholder="Latitude"
              value={lat}
              type="number"
              onChange={onChangeOfLat}
              style={{
                        
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
            />
          </Form.Field>


       
          
      
        <Form.Field required style={{width:"54%","margin-left": "2px"}}>
            <input
              placeholder="Longitude"
              value={lng}
              type="number"
              onChange={onChangeOfLng}
              style={{
                        
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
            />
          </Form.Field>

         

      
          </div >



          </Form>
          <Button color='blue' onClick={handleSubmit} style={{ width: "100%","padding": "20px","font-size": "20px"}}>CREATE</Button>

      </Grid.Column>
    </Grid.Row>
</Grid>

  
  
    
    
    /* <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title>Create Vending Machine Cohort</title>
    </Helmet> */

    
    /* <Grid.Row centered>
      <Grid.Column width={4}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Create Vending Machine Cohort
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Name</label>
            <input
              disabled={submitting}
              value={name}
              onChange={onChangeOfName}
              placeholder="Example: Film City Cohort"
            />
          </Form.Field>
          <Form.Field required>
            <label>Area Name</label>
            <input
              disabled={submitting}
              value={areaName}
              onChange={onChangeOfAreaName}
              placeholder="Example: Noida Sector 16"
            />
          </Form.Field>
          <Form.Field required>
            <label>Description</label>
            <input
              disabled={submitting}
              value={description}
              onChange={onChangeOfDescription}
              placeholder="Why you are making this Cohort?"
            />
          </Form.Field>
          <Form.Field>
            <label>Latitude</label>
            <input
              disabled={submitting}
              value={lat}
              onChange={onChangeOfLat}
              placeholder="Example: 23.90"
            />
          </Form.Field>
          <Form.Field required>
            <label>Longitude</label>
            <input
              disabled={submitting}
              value={lng}
              onChange={onChangeOfLng}
              placeholder="Example: 89.32"
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Vending Machines</label>
            <Dropdown
              disabled={vmLoading || submitting}
              onChange={onChangeOfVM}
              selection
              search
              multiple
              options={vmList || []}
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Users</label>
            <Dropdown
              disabled={userLoading || submitting}
              onChange={onChangeOfUser}
              selection
              search
              multiple
              options={userList || []}
            />
          </Form.Field>
          <Form.Field />
          <br />
          <br />
          <Button
            loading={submitting}
            onClick={handleSubmit}
            basic
            color="blue"
            style={{ float: 'right' }}
          >
            Save Cohort
          </Button>
          <Button
            loading={submitting}
            onClick={handleBack}
            basic
            color="green"
            style={{ float: 'left' }}
          >
            Back to Listing
          </Button>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </Form>
      </Grid.Column>
    </Grid.Row> */
 /*  </Grid> */
);

export default CreateVMCohertForm;



// WEBPACK FOOTER //
// ./src/Modules/VMCohortCreate/component.jsx